/*global jQuery*/
(function($) {

  'use strict';

  $('#cartTabs > li').on('click', () => false);

}(jQuery));
